import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormsModule,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ModalService } from '@app/_services/_common/modal.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule, NzJustify } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { Subscription } from 'rxjs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
@Component({
  selector: 'app-reset-password',
  imports: [
    NzCardModule,
    NzButtonModule,
    NzFormModule,
    NzFlexModule,
    NzSelectModule,
    NzInputModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NzIconModule,
    NzToolTipModule,
  ],
  templateUrl: './reset-password-popup.component.html',
  styleUrl: './reset-password-popup.component.scss',
})
export class ResetPasswordPopupComponent {
  private fb = inject(NonNullableFormBuilder);
  private dataSubscription!: Subscription;
  oldPasswordVisible = false;
  newPasswordVisible = false;
  confirmPasswordVisible = false;
  passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#^()[\]])[A-Za-z\d!@#^()[\]]{10,}$/;
passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const form = control as FormGroup;
  const password = form.get('newPassword')?.value;
  const confirmPassword = form.get('confirmNewPassword')?.value;

  if (!confirmPassword) return null;

  if (password !== confirmPassword) {
    form.get('confirmNewPassword')?.setErrors({
      ...form.get('confirmNewPassword')?.errors,
      passwordMismatch: true,
    });
  } else {
    const errors = form.get('confirmNewPassword')?.errors;
    if (errors) {
      delete errors['passwordMismatch'];
      if (!Object.keys(errors).length) {
        form.get('confirmNewPassword')?.setErrors(null);
      } else {
        form.get('confirmNewPassword')?.setErrors(errors);
      }
    }
  }

  return null;
};
  userForm = this.fb.group(
    {
      oldPassword: this.fb.control('', [Validators.required]),
      newPassword: this.fb.control('', [
        Validators.required,
        Validators.pattern(this.passwordRegex),
      ]),
      confirmNewPassword: this.fb.control('', [Validators.required]),
    },
    { validators: this.passwordMatchValidator }
  );

  ngOnInit(): void {}

  toggleOldEye(): void {
    this.oldPasswordVisible = !this.oldPasswordVisible;
  }
  toggleNewEye(): void {
    this.newPasswordVisible = !this.newPasswordVisible;
  }

  toggleCnfEye(): void {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  submitForm(): any {
    if (this.userForm.valid) {
      return true;
    } else {
      Object.values(this.userForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return false;
    }
  }
}
